export const weather_api_key = "068578c46d8d37243d746e79790a94ac";